/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ tag: NonNullable<unknown> }} Error_Zns_Template_Tag_MismatchInputs */

const vi_error_zns_template_tag_mismatch = /** @type {(inputs: Error_Zns_Template_Tag_MismatchInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mẫu thuộc loại ${i?.tag}, mục đích này cần loại Giao dịch — chọn mẫu khác.`)
};

/**

* @param {Error_Zns_Template_Tag_MismatchInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_zns_template_tag_mismatch = /** @type {((inputs: Error_Zns_Template_Tag_MismatchInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Zns_Template_Tag_MismatchInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_zns_template_tag_mismatch(inputs)
});